import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../../features/users/models/user';

@Component({
  selector: 'app-iroyal-image',
  templateUrl: './iroyal-image.component.html',
  styleUrls: ['./iroyal-image.component.scss']
})
export class IroyalImageComponent implements OnInit {
  @Input() user: Pick<User, 'imageUrl' | 'firstName' | 'lastName' | 'privateProfile'>
  constructor() { }

  ngOnInit(): void {
  }

}
